function AttachmentIcon({ color = "currentColor", className, style }) {
  return (
    <svg width={38} height={42} viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={{ color, ...style }}>
      <path d="M1.667.917v12a5.333 5.333 0 1010.666 0v-8a2.667 2.667 0 10-5.333 0v9.333m9.333-12h17.334a2.667 2.667 0 012.666 2.667v32a2.667 2.667 0 01-2.666 2.666H7a2.667 2.667 0 01-2.667-2.666V22.25m25.334-9.333H19m10.667 8H19m10.667 8H11" stroke="currentColor" strokeWidth={3} />
    </svg>
  );
}
export default AttachmentIcon;
